export default "__VITE_ASSET__v_STGZgg__"